import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Terms() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <div className="bg-[#1a2332] text-white py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm mb-6 md:mb-8 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            {t("legal.backHome")}
          </Link>
          <p className="text-xs text-white/40 tracking-[0.3em] uppercase mb-3">LEGAL</p>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-black">{t("footer.terms")}</h1>
          <p className="text-sm text-white/40 mt-3">{t("legal.lastUpdated")}: 2026年4月4日</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10 py-10 md:py-20">
        <div className="bg-white rounded-2xl border border-gray-100 p-5 sm:p-8 md:p-12 space-y-8 md:space-y-10 text-sm text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第1条（適用）</h2>
            <p>本利用規約（以下「本規約」）は、GlobalBridge Japan株式会社（以下「当社」）が提供するウェブサイト及びサービス（以下「本サービス」）の利用条件を定めるものです。本サービスをご利用いただく全てのユーザー（海外メーカー・パートナー企業・個人を含む）は、本規約に従って本サービスをご利用いただきます。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第2条（定義）</h2>
            <p>本規約において使用する用語の定義は以下のとおりです。</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600">
              <li>「ユーザー」とは、本サービスを利用する全ての方をいいます。</li>
              <li>「パートナー企業」とは、当社と代理店契約・業務提携契約を締結した企業をいいます。</li>
              <li>「コンテンツ」とは、本サービス上で提供される情報・文章・画像・動画等をいいます。</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第3条（禁止事項）</h2>
            <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
              <li>当社のサービスの運営を妨害するおそれのある行為</li>
              <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
              <li>不正アクセスをし、またはこれを試みる行為</li>
              <li>他のユーザーまたは第三者に成りすます行為</li>
              <li>当社の知的財産権を侵害する行為</li>
              <li>当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
              <li>競合他社による情報収集・調査目的での利用</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第4条（知的財産権）</h2>
            <p>本サービス上のコンテンツ（文章・画像・ロゴ・デザイン等）に関する著作権その他の知的財産権は、当社または正当な権利者に帰属します。ユーザーは、当社の事前の書面による承諾なく、これらを複製・転用・転載することはできません。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第5条（本サービスの提供の停止等）</h2>
            <p>当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600">
              <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
              <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
              <li>コンピュータまたは通信回線等が事故により停止した場合</li>
              <li>その他、当社が本サービスの提供が困難と判断した場合</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第6条（免責事項）</h2>
            <p>当社の債務不履行責任は、当社の故意または重過失によらない場合には免責されるものとします。当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。また、本サービスに掲載する情報の正確性・完全性・有用性について保証するものではありません。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第7条（サービス内容の変更等）</h2>
            <p>当社は、ユーザーへの事前の告知をもって、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第8条（利用規約の変更）</h2>
            <p>当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。本規約の変更がユーザーの一般の利益に適合するとき、または本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">第9条（準拠法・裁判管轄）</h2>
            <p>本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、大阪地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
          </section>
        </div>
      </div>
    </div>
  );
}
